import { render } from "./ListarAvaliacoesDesempenho.vue?vue&type=template&id=e29abeb0&scoped=true"
import script from "./ListarAvaliacoesDesempenho.vue?vue&type=script&lang=js"
export * from "./ListarAvaliacoesDesempenho.vue?vue&type=script&lang=js"

import "./ListarAvaliacoesDesempenho.vue?vue&type=style&index=0&id=e29abeb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29abeb0"]])

export default __exports__